import { render, staticRenderFns } from "./GiftCardForm.vue?vue&type=template&id=5efe9993&scoped=true&"
import script from "./GiftCardForm.vue?vue&type=script&lang=js&"
export * from "./GiftCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe9993",
  null
  
)

export default component.exports